// VFX: Cinematic Light Leak
// Category: light-leaks  ·  Tags: overlay, light-leak, cinematic, film, organic
// Organic light leak cinematic overlay.
import React from "react";
import {AbsoluteFill, useCurrentFrame, interpolate} from "remotion";
export const CinematicLightLeak: React.FC<{
  color?: string; intensity?: number; position?: "top"|"bottom"|"corner";
}> = ({color="#ff9966", intensity=0.4, position="top"}) => {
  const frame = useCurrentFrame();
  const t = frame * 0.01;
  const pulse = Math.sin(t) * 0.2 + 0.8;
  const drift = Math.sin(t * 0.7) * 8;
  const posStyle = position === "top" ? {top:"-10%", left:`${40+drift}%`}
    : position === "bottom" ? {bottom:"-10%", left:`${30+drift}%`}
    : {top:"-5%", right:"-5%"};
  return (
    <AbsoluteFill style={{pointerEvents:"none", mixBlendMode:"screen"}}>
      <div style={{
        position:"absolute", ...posStyle,
        width:"50%", height:"45%",
        background:`radial-gradient(ellipse at center, ${color} 0%, ${color}88 25%, transparent 70%)`,
        opacity: intensity * pulse,
        filter:"blur(30px)",
        transform:`rotate(${Math.sin(t*0.5)*15}deg)`,
      }} />
      <div style={{
        position:"absolute",
        top: position === "top" ? "0%" : "auto",
        bottom: position === "bottom" ? "0%" : "auto",
        left:"0%", right:"0%", height:"15%",
        background:`linear-gradient(${position==="bottom"?"0deg":"180deg"}, ${color}33, transparent)`,
        opacity: intensity * 0.5,
      }} />
    </AbsoluteFill>
  );
};

export default function OverlayLightLeakCinematicLoop() {
  return <CinematicLightLeak />;
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
